// TODO: have one route handler file & function per registered route in routes.ts
export default function routeHandler() {
    // Do some action
}
